/** @jsxImportSource react */
import DatahubContext from '@react/data-hub/context/datahubContext';
import useSearchInsights from '@react/data-hub/hooks/useSearchInsights';
import React from 'react';

import { InsightsFilters, RenderChartOutput } from '../types/misc';

const DatahubContextProvider = ({
  chartSvgs,
  filters,
  children,
}: {
  chartSvgs?: RenderChartOutput;
  filters: InsightsFilters;
  children: React.ReactNode;
}) => {
  const {
    searchInsights,
    locationString,
    locationStringWithCountryCode,
    metadata,
  } = useSearchInsights({ filters });
  return (
    <DatahubContext.Provider
      value={{
        searchInsights,
        locationString,
        locationStringWithCountryCode,
        metadata,
        chartSvgs,
      }}
    >
      {children}
    </DatahubContext.Provider>
  );
};

export default DatahubContextProvider;
